import { render, staticRenderFns } from "./TherapyCounselling.vue?vue&type=template&id=ef8f1030"
import script from "./TherapyCounselling.vue?vue&type=script&lang=js"
export * from "./TherapyCounselling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports